import styled from 'styled-components'

import { mq, sizes } from '../../theme'

export const WysiwygContainer = styled.div`
  ${({ theme }) => theme.textStyles.text_16}
  color: ${({ theme }) => theme.colors.pureBlack};

  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.text_18}
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${({ theme }) => theme.colors.pureBlack};
  }

  h1 {
    ${({ theme }) => theme.textStyles.titleH1_26};

    @media ${mq(sizes.desktop)} {
      ${({ theme }) => theme.textStyles.titleH1_36};
    }
  }

  h2 {
    ${({ theme }) => theme.textStyles.titleH2_23};

    @media ${mq(sizes.desktop)} {
      ${({ theme }) => theme.textStyles.titleH2_30};
    }
  }

  // FIXME: Hardcoded (need appropriate font-size from designers)
  h3 {
    font-size: 2.17rem;
  }

  h4 {
    font-size: 2rem;
  }

  h5 {
    font-size: 1.83rem;
  }

  h6 {
    font-size: 1.75rem;
  }

  ul,
  ol {
    padding: 0 0 0 4rem;
  }

  strong {
    ${({ theme }) => theme.textStyles.text_bold_16}

    @media ${mq(sizes.desktop)} {
      ${({ theme }) => theme.textStyles.text_bold_18}
    }
  }

  em {
    & * {
      font-size: italic;
    }
  }

  a {
    color: ${({ theme }) => theme.colors.pureBlack};
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-color: ${({ theme }) => theme.colors.pureBlack};
    text-decoration-thickness: 2px;
    text-underline-position: under;
    padding-bottom: 0.1rem;

    ${({ theme }) => theme.textStyles.text_medium_16}

    &:hover {
      color: ${({ theme }) => theme.colors.redMojo};
      text-decoration-color: ${({ theme }) => theme.colors.redMojo};
    }

    @media ${mq(sizes.desktop)} {
      padding-bottom: 0.2rem;
      ${({ theme }) => theme.textStyles.text_medium_18}
    }
  }

  blockquote {
    background: ${({ theme }) => theme.colors.greyDD};
    border-left: 2px solid ${({ theme }) => theme.colors.pureBlack};
    padding: 1rem;
  }
`
